import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { translations } from "./locales";

const resources = Object.keys(translations).reduce((acc, lang) => {
  acc[lang] = { translation: translations[lang] };
  return acc;
}, {});

i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources,
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
